"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var locale = {
  placeholder: "Sélectionner l'heure",
  rangePlaceholder: ['Heure de début', 'Heure de fin']
};
var _default = locale;
exports["default"] = _default;